/**
 * Client-facing dividend UI kill-switch.
 * Engine (calculationService, eligibility) stays in place. Flip to true to restore surfaces.
 */
export const DIVIDENDS_USER_VISIBLE = true;
